import React, { FC } from 'react';

import { Link } from '@rover/kibble/core';

import useLogo from './hooks/useLogo';

const BrandLink: FC = () => {
  const { logoAriaLabel, logoHref, Logo } = useLogo();

  return (
    <Link
      href={logoHref}
      aria-label={logoAriaLabel}
      marginLeft={['-1x', '0x']}
      sx={{
        '&:focus, &:hover': {
          textDecoration: 'none',
        },
      }}
    >
      <Logo />
    </Link>
  );
};

export default BrandLink;
